import React, { useEffect, useState } from 'react'

import {
  Card,
  ErrorBoundary
} from 'components'
import { useGet, usePersistForm } from 'hooks'
import moment from 'moment'
import { useForm, FormProvider } from 'react-hook-form'
import { IConsultaDocumentosGetByFilterParams, IDocumentosGetByFilterResponse } from 'services/GST/DocumentosItensSeguranca'
import { FUNCTIONS, SPACING } from 'utils'

import DocumentsTable from './components/DocumentsTable'
import SearchForm from './components/SearchForm'
import { IForm } from './types'

const Documents: React.FC = () => {
  const methods = useForm<IForm>({
    defaultValues: {
      cdContrato: '',
      centroPlantaId: undefined,
      documentoStatus: undefined,
      dtAnexadoFinal: null,
      dtAnexadoInicial: null,
      dtRetornoFinal: null,
      dtRetornoInicial: null,
      empresaId: undefined,
      //'enviarListas = true' no primeiro get, para obter as listas dos filtros
      enviarListas: true,
      itemSegurancaId: undefined,
      nmFornecedor: ''
    }
  })

  usePersistForm('search-consult-documents-form', {
    setValue: methods.setValue,
    watch: methods.watch
  })

  const [filterLists, setFilterLists] = useState<IDocumentosGetByFilterResponse>()
  const [datesStatusOk, setDatesStatusOk] = useState<boolean>(true)
  const {
    data,
    refresh: refreshTable,
    isFirstGet: isFirstGet,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage
  } = useGet<IConsultaDocumentosGetByFilterParams, IDocumentosGetByFilterResponse>({
    api: 'Gst',
    isPaginated: true,
    params: {
      ...FUNCTIONS.filterObject(methods.getValues(), Boolean),
    },
    url: 'ItensAnexados/GetByFilter'
  })

  const handleSubmitForm = (form: IForm) => {
    // Paginação pelo BACKEND.
    const formFormatado: IForm = {
      ...form,
      dtAnexadoFinal: form.dtAnexadoFinal && moment(form.dtAnexadoFinal).format('YYYY-MM-DD'),
      dtAnexadoInicial: form.dtAnexadoInicial && moment(form.dtAnexadoInicial).format('YYYY-MM-DD'),
      dtRetornoFinal: form.dtRetornoFinal && moment(form.dtRetornoFinal).format('YYYY-MM-DD'),
      dtRetornoInicial: form.dtRetornoInicial && moment(form.dtRetornoInicial).format('YYYY-MM-DD'),
    }
    refreshTable({
      ...FUNCTIONS.filterObject(formFormatado, Boolean)
    })
  }

  useEffect(() => {
    if (!isFirstGet) {
      /* 
      * FilterLists contem as listas para os filtros de
      * Empresas, Status e Item Segurança. Ela é recebida e setada apenas
      * no get inicial da tela, à partir da flag enviarListas = true, 
      * para utilização das listas no componente SearchForm. 
      */
      setFilterLists(data)
    }
  }, [isFirstGet])

  return (
    <FormProvider {...methods}>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <SearchForm
          handleSubmitForm={handleSubmitForm}
          refreshTable={handleSubmitForm}
          filterLists={filterLists}
          setDatesStatusOk={setDatesStatusOk}
          datesStatusOk={datesStatusOk}
          isFirstGet={isFirstGet}
        />
        <ErrorBoundary>
          <DocumentsTable
            tableData={data?.entity?.paginatedItens}
            datesStatusOk={datesStatusOk}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </ErrorBoundary>
      </Card>
    </FormProvider>
  )
}

export default Documents
